import {Vue} from 'ui.vue';
import "promise";
Vue.use({
    install:function(Vue,options){

        Vue.getPromise = function(data){
            var p = new BX.Promise();
            p.resolve(data);
            return p;
        }
        Vue.prototype.$baseAdapter = function(data){
            return Vue.getPromise(data.data);
        }

    }
},{ someOption: true });